const lanePositions = { top: 0, jungle: 1, middle: 2, bottom: 3, support: 4 };

const laning = [400, 420, 430, 440, 490];

const calcLanes = (lanes, queue) => {
  const isLaning = laning.indexOf(queue) !== -1 ? true : false;
  const order = [
    [0, 1, 2, 3, 4],
    [5, 6, 7, 8, 9],
  ];
  if (!lanes || !isLaning) return order;
  let newOrder = [
    [0, 1, 2, 3, 4],
    [5, 6, 7, 8, 9],
  ];
  order.forEach((team, i) =>
    team.forEach((p, j) => {
      newOrder[i][lanePositions[lanes[p]]] = p;
    })
  );
  return newOrder;
};

export default calcLanes;
